export default "__VITE_ASSET__DgJkKvyZ__"